/**
 * Country Selector Component
 * Opens the country modal as a native <dialog> in the browser top layer,
 * which paints above every z-index / transform / stacking context on the
 * page. Esc handling, focus trapping, and inert background come from the
 * platform — no manual keyboard code needed.
 */

(() => {
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {};
    }

    connectedCallback() {
      this.elements = {
        button: this.querySelector('.disclosure__button'),
        modal: this.querySelector('.country-selector_modal'),
        select: this.querySelector('#countrySelect'),
        saveBtn: this.querySelector('#country-selector__save-btn'),
        input: this.querySelector('#selected-country-code'),
        close: this.querySelector('.country-selector_modal--close')
      };

      if (this.elements.button) {
        this.elements.button.addEventListener('click', this.openModal.bind(this));
      }
      if (this.elements.saveBtn) {
        this.elements.saveBtn.addEventListener('click', this.onSave.bind(this));
      }
      if (this.elements.close) {
        this.elements.close.addEventListener('click', () => this.closeModal());
      }
      if (this.elements.modal) {
        // Clicks on ::backdrop report the <dialog> itself as the target;
        // clicks inside the card hit its descendants.
        this.elements.modal.addEventListener('click', (event) => {
          if (event.target === this.elements.modal) this.closeModal();
        });
        // Fires on EVERY close path — close(), native Esc, etc. — so state
        // cleanup lives in exactly one place and can't drift.
        this.elements.modal.addEventListener('close', this.onClosed.bind(this));
      }
    }

    openModal() {
      const { modal, button } = this.elements;
      if (!modal || typeof modal.showModal !== 'function') return;

      modal.showModal();
      if (button) button.setAttribute('aria-expanded', 'true');
      document.body.classList.add('no-scroll');
    }

    closeModal() {
      const { modal } = this.elements;
      if (modal && modal.open) modal.close();
    }

    onClosed() {
      const { button } = this.elements;
      if (button) {
        button.setAttribute('aria-expanded', 'false');
        button.focus();
      }
      document.body.classList.remove('no-scroll');
    }

    onSave(event) {
      event.preventDefault();

      const form = this.querySelector('form');
      if (this.elements.input && this.elements.select) {
        this.elements.input.value = this.elements.select.value;
      }
      if (form) form.submit();
    }
  }

  if (!customElements.get('localization-form')) {
    customElements.define('localization-form', LocalizationForm);
  }
})();
